module.exports = __webpack_public_path__ + "static/media/drowning_under_stetho.26479df7.jpg";